export class SortModel {
    unsorted: boolean;
    sorted: boolean;
    empty: boolean;
}